import { CommonAction } from '../../../login/redux/types';
import AnnouncementsTypes, { Announcement } from './types';

function fetchAnnoucementReq(): CommonAction {
    return {
        type: AnnouncementsTypes.FETCH_ANNOUNCEMENTS_REQ,
        payload: null,
    };
}

function setAnnoucements(annoucements: Announcement[]): CommonAction {
    return {
        type: AnnouncementsTypes.SET_ANNOUNCEMENTS,
        payload: annoucements,
    };
}

const AnnoucementActions = {
    fetchAnnoucementReq,
    setAnnoucements,
};

export default AnnoucementActions;
